var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { createPopupViewModel, CssClassBuilder } from "survey-core";
import { ReactElementFactory } from "../../element-factory";
import { SurveyElementBase } from "../../reactquestion_element";
import { SurveyActionBar } from "../action-bar/action-bar";
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = React.createRef();
        _this.createModel();
        return _this;
    }
    Object.defineProperty(Popup.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Popup.prototype.getStateElement = function () {
        return this.model;
    };
    Popup.prototype.createModel = function () {
        this.popup = createPopupViewModel(this.props.model);
    };
    Popup.prototype.setTargetElement = function () {
        var container = this.containerRef.current;
        this.popup.setComponentElement(container);
    };
    Popup.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.setTargetElement();
    };
    Popup.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.setTargetElement();
    };
    Popup.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.popup.resetComponentElement();
    };
    Popup.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var _a;
        if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState))
            return false;
        var isNeedUpdate = nextProps.model !== this.popup.model;
        if (isNeedUpdate) {
            (_a = this.popup) === null || _a === void 0 ? void 0 : _a.dispose();
            this.createModel();
        }
        return isNeedUpdate;
    };
    Popup.prototype.render = function () {
        this.popup.model = this.model;
        var popupContainer;
        if (this.model.isModal) {
            popupContainer = React.createElement(PopupContainer, { model: this.popup });
        }
        else {
            popupContainer = React.createElement(PopupDropdownContainer, { model: this.popup });
        }
        return React.createElement("div", { ref: this.containerRef }, popupContainer);
    };
    return Popup;
}(SurveyElementBase));
export { Popup };
ReactElementFactory.Instance.registerElement("sv-popup", function (props) {
    return React.createElement(Popup, props);
});
var PopupContainer = /** @class */ (function (_super) {
    __extends(PopupContainer, _super);
    function PopupContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeydown = function (event) {
            _this.model.onKeyDown(event);
        };
        _this.clickInside = function (ev) {
            ev.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(PopupContainer.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    PopupContainer.prototype.getStateElement = function () {
        return this.model;
    };
    PopupContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        if (!this.model.isPositionSet && this.model.isVisible) {
            this.model.updateOnShowing();
        }
    };
    PopupContainer.prototype.renderContainer = function (popupBaseViewModel) {
        var _this = this;
        var headerPopup = popupBaseViewModel.showHeader ? this.renderHeaderPopup(popupBaseViewModel) : null;
        var headerContent = !!popupBaseViewModel.title ? this.renderHeaderContent() : null;
        var content = this.renderContent();
        var footerContent = popupBaseViewModel.showFooter ? this.renderFooter(this.model) : null;
        return (React.createElement("div", { className: "sv-popup__container", style: {
                left: popupBaseViewModel.left,
                top: popupBaseViewModel.top,
                height: popupBaseViewModel.height,
                width: popupBaseViewModel.width,
                minWidth: popupBaseViewModel.minWidth,
            }, onClick: function (ev) {
                _this.clickInside(ev);
            } },
            headerPopup,
            React.createElement("div", { className: "sv-popup__body-content" },
                headerContent,
                React.createElement("div", { className: "sv-popup__scrolling-content" }, content),
                footerContent)));
    };
    PopupContainer.prototype.renderHeaderContent = function () {
        return React.createElement("div", { className: "sv-popup__body-header" }, this.model.title);
    };
    PopupContainer.prototype.renderContent = function () {
        var contentComponent = ReactElementFactory.Instance.createElement(this.model.contentComponentName, this.model.contentComponentData);
        return React.createElement("div", { className: "sv-popup__content" }, contentComponent);
    };
    PopupContainer.prototype.renderHeaderPopup = function (popupModel) {
        return null;
    };
    PopupContainer.prototype.renderFooter = function (popuModel) {
        return (React.createElement("div", { className: "sv-popup__body-footer" },
            React.createElement(SurveyActionBar, { model: popuModel.footerToolbar })));
    };
    PopupContainer.prototype.render = function () {
        var _this = this;
        var container = this.renderContainer(this.model);
        var className = new CssClassBuilder()
            .append("sv-popup")
            .append(this.model.styleClass)
            .toString();
        var style = { display: this.model.isVisible ? "" : "none", };
        return (React.createElement("div", { tabIndex: -1, className: className, style: style, onClick: function (e) {
                _this.model.clickOutside(e);
            }, onBlur: function (e) {
                _this.model.blur(e);
            }, onKeyDown: this.handleKeydown }, container));
    };
    PopupContainer.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (this.model.isVisible) {
            this.model.updateOnShowing();
        }
    };
    return PopupContainer;
}(SurveyElementBase));
export { PopupContainer };
var PopupDropdownContainer = /** @class */ (function (_super) {
    __extends(PopupDropdownContainer, _super);
    function PopupDropdownContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupDropdownContainer.prototype.renderHeaderPopup = function (popupModel) {
        var popupDropdownModel = popupModel;
        if (!popupDropdownModel)
            return null;
        return (React.createElement("span", { style: {
                left: popupDropdownModel.pointerTarget.left,
                top: popupDropdownModel.pointerTarget.top,
            }, className: "sv-popup__pointer" }));
    };
    return PopupDropdownContainer;
}(PopupContainer));
export { PopupDropdownContainer };
